// extracted by mini-css-extract-plugin
export default {"nav_sccom":"TwoColumnLayout__nav_sccom--ig-plCsZ"};